import { render, staticRenderFns } from "./EscuelaView.vue?vue&type=template&id=e601903c&"
import script from "./EscuelaView.vue?vue&type=script&lang=js&"
export * from "./EscuelaView.vue?vue&type=script&lang=js&"
import style0 from "./EscuelaView.vue?vue&type=style&index=0&id=e601903c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports